<template>
  <div class="wrap__person">

    <div class="nav-tree">
      <el-button v-if="companyLayout" @click="addPerson" :disabled="disabledBtn || !companyLayout.permission.addVendorsPerson" class="nav-tree__item" size="mini" type="menu" icon="el-icon-plus">{{$t('vendors_btn_add_person')}}</el-button>
      <el-button v-if="companyLayout" :disabled="!companyLayout.permission.updateVendorsPerson" @click="editPerson" v-show="showBtn" class="nav-tree__item" size="mini" type="menu" icon="el-icon-edit">{{$t('vendors_btn_edit_person')}}</el-button>
      <el-tooltip effect="dark" content="Delete Person" placement="bottom">
        <el-button v-if="companyLayout" :disabled="!companyLayout.permission.deleteVendorsPerson" @click="deletePerson" v-show="showBtn" class="nav-tree__item" size="mini" type="menu" icon="el-icon-delete"></el-button>
      </el-tooltip>
    </div>

    <ag-grid-vue style="width: 100%; height: 92%;" class="ag-theme-balham" id="myGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :getRowHeight="getRowHeight"
      :rowDragManaged="true"
      :animateRows="true"
      :rowData="rowData"
      :rowSelection="rowSelection"
      @selection-changed="onSelectionChanged"
      suppressContextMenu="true"></ag-grid-vue>

    <!-- [ Modal form Add Person ] start -->
    <AddPerson ref="modal3" :directories="directories" @selected="selected"/>
    <!-- [ Modal form Add Person ] end -->

    <!-- [ Modal form Edit Person ] start -->
    <EditPerson ref="modal4" :directories="directories" :companyVendorsPersonsItem="companyVendorsPersonsItem" @selected="selected"/>
    <!-- [ Modal form Edit Person ] end -->
  </div>
</template>

<script>
import AddPerson from '@/components/vendors/AddPerson.vue'
import EditPerson from '@/components/vendors/EditPerson.vue'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import {AgGridVue} from "ag-grid-vue"
import axios from 'axios'
export default {
  components: {
    AgGridVue,
    SweetModal,

    AddPerson,
    EditPerson,
  },
  props: {
    rowData: {
      type: Array,
      default: function () {
        return []
      }
    },
    disabledBtn: Boolean,
  },
  computed: {
    companyLayout() {
      return this.$store.state.companyLayout
    }
  },
  data() {
    return {
      showBtn: false,
      selectedRow: null,

      directories: null,
      companyVendorsPersonsItem: null,

      // Tree
      gridOptions: null,
      gridApi: null,
      getRowHeight:null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowSelection: null,
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
      overlayNoRowsTemplate: this.$i18n.t('general_noRowsToShow'),
    };
    this.columnDefs = [
      { field: this.$i18n.t('vendors_id'),
        headerClass: 'id-column',
        width:50,
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.id}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex; justify-content:center;'}
        }
      },
      { field: this.$i18n.t('vendors_name'),
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.name}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex;'}
        }
      },
      { field: this.$i18n.t('vendors_email'),
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.email}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex;'}
        }
      },
      { field: this.$i18n.t('vendors_phone'),
        cellRenderer: function(params) {
          if(params.node.data.phone){
            return `<span class="txtRender">${params.node.data.phone}</span>`
          }
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex;'}
        }
      }
    ];
    this.defaultColDef = {
      suppressMovable: true,
      suppressMenu: true,
      resizable: true,
      width: 150,
      filter: true
    };
    this.getRowHeight = params => {
      return 40;
    };
    this.rowSelection = "single";
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApi.sizeColumnsToFit();
  },
  methods: {
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    addPerson() {
      console.log('---', 'addPerson');
      // this.$refs.addPerson.open();
      this.$refs['modal3'].$refs['addPerson'].open()

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyVendorPersons/directories?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}&operation=create`)
        .then(response => {
          console.log('---/companyVendorPersons/directories', response.data);
          // this.arrCountryId = response.data.countryList
          // this.arrStateId = response.data.stateList
          // this.arrCityId = response.data.cityList
          this.directories = response.data
        })
        .catch(error => {
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear()
          //   this.$router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
    },
    editPerson() {
      console.log('---', 'editPerson');
      // this.$refs.editPerson.open();
      this.$refs['modal4'].$refs['editPerson'].open()

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyVendorPersons/item?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}&companyVendorPersonId=${this.$route.query.companyVendorPersonId}`)
        .then(response => {
          console.log('---/companyVendorPersons/item', response.data);
          this.companyVendorsPersonsItem = response.data.item

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyVendorPersons/directories?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}&operation=update`)
            .then(response => {
              console.log('---/companyVendorPersons/directories', response.data);
              this.directories = response.data
            })
            .catch(error => {
              // if (error.response.data.statusCode == 401) {
              //   localStorage.clear()
              //   this.$router.push('/login')
              // }
              console.log('An error occurred:', error);
            });
        })
        .catch(error => {
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear()
          //   this.$router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
    },
    deletePerson() {
      this.$confirm('This will permanently delete the person. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        console.log('---', 'deletePerson');
        let selectedRows = this.gridApi.getSelectedRows();
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/companyVendorPersons/delete?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}&companyVendorPersonId=${this.$route.query.companyVendorPersonId}`)
            .then(response => {
                console.log('---/companyVendorPersons/delete', response.data);
                this.$emit('deletePerson')
                // this.$store.dispatch('getRowDataVendorsPerson');
                this.notification("Success", "Delete Persons", "success");
                loader.hide()
            })
            .catch(error => {
                // if (error.response.data.statusCode == 401) {
                //     localStorage.clear()
                //     this.$router.push('/login')
                // }
                console.log('An error occurred:', error);
                loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    selected(id) {
      var selectedId = id
      if (selectedId) {
        setTimeout(() => {
          this.selectCreatedTask(selectedId)
        }, 2000);
      } else {
        setTimeout(() => {
          this.selectCreatedTask(this.selectedRow[0].vendorPersonId)
        }, 2000);
      }
    },

    // [ Tree ] start
    selectCreatedTask(id){
      this.gridApi.forEachNode(function (node) {
        console.log("NODE DATA", node.data.vendorPersonId)
        console.log("NODE DATA ID COMPARE", id)
        if (node.data.vendorPersonId === id) {
          node.setSelected(true);
          console.log("NODE SELECTED")
        }
      });
    },
    onBtSuppressRowDrag() {
      this.gridApi.setSuppressRowDrag(true);
    },
    onBtShowRowDrag() {
      this.gridApi.setSuppressRowDrag(false);
    },
    onGridReady(params) {},
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.selectedRow = this.gridApi.getSelectedRows();
      this.$emit('selectedPerson', selectedRows[0])
      this.showBtn = true;
      console.log('---ROW', selectedRows);

      // localStorage.setItem('companyVendorPersonId', selectedRows[0].vendorPersonId)
      this.$router.push(`/vendors?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}&companyVendorPersonId=${selectedRows[0].vendorPersonId}`);
    },
    // [ Tree ] end
  },
}
</script>

<style lang="scss" scoped>
.nav-tree {
  padding-bottom: 10px;
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}

// [ Modal ] start
.button{
  cursor: pointer;
}
// [ Modal ] end
</style>
